import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App'; 
import axios from 'axios';
import reportWebVitals from './reportWebVitals';
const root = ReactDOM.createRoot(document.getElementById('root'));
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL; // Dev
if(sessionStorage.getItem("admin_user_token")){
  axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("admin_user_token")}` }
}
root.render(
  //<React.StrictMode>
    <App />
  //</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
